import React from "react";
import styled from "styled-components";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import { Noindex } from "../Noindex";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <PrivacyPolicyDiv>
      <div>
        <h1>{t("privacyPolicy.title")}</h1>

        <p>{t("privacyPolicy.introduction")}</p>
        <p>{t("privacyPolicy.information")}</p>
        <p>{t("privacyPolicy.informationContent")}</p>
        <ul>
          <li>{t("privacyPolicy.informationPoint1")}</li>
          <li>{t("privacyPolicy.informationPoint2")}</li>
          <li>{t("privacyPolicy.informationPoint3")}</li>
        </ul>

        <h3>{t("privacyPolicy.howWeUse")}</h3>
        <p>{t("privacyPolicy.howWeUseContent")}</p>
        <ul>
          <li>{t("privacyPolicy.howWeUsePoint1")}</li>
          <li>{t("privacyPolicy.howWeUsePoint2")}</li>
          <li>{t("privacyPolicy.howWeUsePoint3")}</li>
          <li>{t("privacyPolicy.howWeUsePoint4")}</li>
        </ul>

        <h3>{t("privacyPolicy.howWeStore")}</h3>
        <p>{t("privacyPolicy.howWeStoreContent")}</p>

        <h3>{t("privacyPolicy.sharingInformation")}</h3>
        <p>{t("privacyPolicy.sharingInformationContent")}</p>

        <h3>{t("privacyPolicy.cookies")}</h3>
        <p>{t("privacyPolicy.cookiesContent")}</p>

        <h3>{t("privacyPolicy.yourRights")}</h3>
        <p>{t("privacyPolicy.yourRightsContent")}</p>

        <h3>{t("privacyPolicy.changes")}</h3>
        <p>{t("privacyPolicy.changesContent")}</p>

        <h3>{t("privacyPolicy.contactUs")}</h3>
        <p
          dangerouslySetInnerHTML={{
            __html: t("privacyPolicy.contactUsContent"),
          }}
        ></p>
      </div>
      <Footer />
      <Noindex routeKey="privacyPolicy" />
    </PrivacyPolicyDiv>
  );
};

const PrivacyPolicyDiv = styled.div`
  width: 100%;
  height: auto;
  overflow-x: hidden;
  background: var(--primary);
  & > div:first-child {
    color: var(--white);
    padding: 100px 20px;
    margin: 0 auto;
    height: auto;
    width: 100%;
    max-width: 1440px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    & > h1 {
      margin-bottom: 12px;
      font-size: 55px;
      font-weight: lighter;
    }
    & > h3 {
      font-size: 30px;
      padding-bottom: 10px;
      font-weight: lighter;
    }
    & > ul {
      & > li {
        font-size: 16px;
        line-height: 32px;
        margin-bottom: 20px;
      }
    }
    & > p {
      font-size: 16px;
      line-height: 32px;
    }
  }
`;

export default PrivacyPolicy;
